module.exports = __webpack_public_path__ + "img/gb6183.prt.ee544bf0.jpg";